/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Header from "../../Base/Header";
import Reveiw from "../../Components/creator/review";
import Video from "../../Components/creator/video2";
import styles from "../../Styles/creator/styles.module.css";
import PostReview from "../../Components/Modals/PostReview";
import {
  getFeedbackByPlaylist,
  getPlaylistById,
} from "../../helper/reveiwApiCalls/reveiw";
import axios from "axios";
import { useParams } from "react-router-dom";
import { isAuthenticated } from "../../helper/authApiCalls/auth";
import ReactPaginate from "react-paginate";
import Footer from "../../Base/Footer";

import PlaylistQuiz from "./QuizPage";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";

const Creator = () => {
  const params = useParams();
  const id = params.id;

  const [open, setOpen] = React.useState(false);

  const playlistId = id;
  const [feed, setFeed] = useState([]);
  const [play, setPlay] = useState({});
  const [videos, setVideos] = useState([]);
  const [detail, setDetail] = useState([]);
  const [show, setShow] = useState(false);
  const [loginmessage, setLoginmessage] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [PER_PAGE, setPER_PAGE] = useState(10);
  const [busy, setBusy] = useState(true);
  const [check, setCheck] = useState({});

  //  quiz
  const [quizOpen, setQuizOpen] = useState(false);

  function fetchFeedbacks() {
    getFeedbackByPlaylist(playlistId).then((data) => {
      if (data.status === "fail") {
        console.log(data.message);
      } else {
        setFeed(data);
      }
    });
  }
  console.log(videos, "videos");

  function fetchPlaylist() {
    if (isAuthenticated()) {
      setBusy(true);
      getPlaylistById(playlistId).then((data) => {
        if (data.status === "fail") {
          console.log(data.message);
        } else {
          setPlay(data.data);
          setVideos(data.data.videos);
          setBusy(false);

          // setUrl(data.data.videos);
        }
      });
    } else {
      setLoginmessage("Login");
      setBusy(false);
    }
  }

  // const setUrl = async (videos) => {
  //   // const offset = await console.log(offset + PER_PAGE);
  //   // let j=49
  //   // while (videos.length<49){
  //   //   for (let i=0; i < videos.length; i++) {
  //   //     if (i % offset === 0) {
  //   //       YT_url += videos[i].slice(17);
  //   //     } else {
  //   //       YT_url += "%2C" + videos[i].slice(17);
  //   //     }
  //   //   }
  //   //   YT_url += key;
  //   //   return YT_url;
  //   // }

  //   if (videos?.length > 0) {
  //     for (let i = 0; i < videos.length; i += 40) {
  //       let YT_url =
  //         "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
  //       const key = "&key=AIzaSyDIcBfTRXG5W4G4QzzlkBDSN6W9Y3RXjQM";
  //       let vids = videos.slice(i, i + 40);
  //       for (let i = 0; i < vids.length; i++) {
  //         if (i % offset === 0) {
  //           YT_url += vids[i].slice(17);
  //         } else {
  //           YT_url += "%2C" + vids[i].slice(17);
  //         }
  //       }
  //       YT_url = (await YT_url) + key;
  //       const config = {
  //         method: "get",
  //         url: YT_url,
  //       };
  //       const result = await axios(config);

  //       await setDetail((prevArray) => [...prevArray, ...result.data.items]);
  //     }
  //     setBusy(false);
  //   }
  // };

  function perPageSwitch() {
    if (width > 768) {
      setPER_PAGE(10);
    } else {
      setPER_PAGE(4);
    }
  }

  const offset = currentPage * PER_PAGE;
  const currentPageData = videos
    .slice(offset, offset + PER_PAGE)
    .sort()
    .map((v, index) => {
      return (
        <div key={index}>
          <Video del={true} video={v} playlistId={playlistId} />
        </div>
      );
    });

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const pageCount = Math.ceil(videos.length / PER_PAGE);

  useEffect(() => {
    fetchFeedbacks();
    fetchPlaylist();
    perPageSwitch();
  }, []);

  function ShowMore() {
    setShow(true);
  }

  function ShowLess() {
    setShow(false);
  }
  const width = window.innerWidth;

  function searchUser() {
    if (isAuthenticated()) {
      let obj = feed.find(
        (o) => o.user.toString() === isAuthenticated().id.toString(),
      );
      setCheck(obj);
    }
  }

  useEffect(() => {
    searchUser();
  }, [feed]);
  const paginateDesk = () => {
    return (
      <ReactPaginate
        containerClassName={styles.pagination}
        breakLabel="..."
        nextLabel=">"
        pageRangeDisplayed={3}
        pageCount={pageCount}
        onPageChange={handlePageClick}
        pageClassName={styles.page}
        activeClassName={styles.active}
        nextClassName={styles.next}
        previousClassName={styles.previous}
        breakClassName={styles.break}
        previousLabel="<"
        renderOnZeroPageCount={null}
      />
    );
  };

  return (
    <div>
      <Header />

      {!busy && (
        <div className={styles.creator}>
          <div className={styles.body}>
            <div className={styles.text}>
              <div className={styles.text1}>
                <span>{play.name}</span>
              </div>
              <div className={styles.text2}>
                <span></span>
              </div>
            </div>
            {loginmessage === "Login" ? (
              <div className={styles.messageblock}>
                <p>
                  <a href="/signin" className={styles.alogin}>
                    Please
                    <span className={styles.signup}>{loginmessage}</span>
                    to view the content
                  </a>
                </p>
              </div>
            ) : (
              <div className={styles.videos}>
                <div className={styles.thumnails}>{currentPageData}</div>
                <ReactPaginate
                  containerClassName={styles.pagination}
                  breakLabel="..."
                  nextLabel=">"
                  pageRangeDisplayed={3}
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  pageClassName={styles.page}
                  activeClassName={styles.active}
                  nextClassName={styles.next}
                  previousClassName={styles.previous}
                  breakClassName={styles.break}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                />
              </div>
            )}

            <div className={styles.review}>
              <div className={styles.rtext}>
                <span>Reviews</span>
              </div>
              <div className={styles.button}>
                {isAuthenticated().isVerified === true && (
                  <button onClick={() => setOpen((val) => !val)}>
                    {check === undefined
                      ? "Write a Review"
                      : "Edit your Review"}
                  </button>
                )}
              </div>
            </div>
            <div className={styles.reviews}>
              {show
                ? feed.map((rev, key) => {
                    return (
                      <div key={key}>
                        <Reveiw rev={rev} />
                      </div>
                    );
                  })
                : feed.slice(0, 1).map((rev, key) => {
                    return (
                      <div key={key}>
                        <Reveiw rev={rev} />
                      </div>
                    );
                  })}
            </div>
            {feed.length > 1 && (
              <div className={styles.but}>
                {!show && <button onClick={ShowMore}>Show More reviews</button>}
                {show && <button onClick={ShowLess}>Show Less reviews</button>}
              </div>
            )}
            {feed.length === 0 && (
              <div className={styles.but}>
                <button>No Reveiws yet</button>
              </div>
            )}
            {feed.length === 1 && <div className={styles.but}></div>}

            {open && (
              <PostReview open={open} setOpen={setOpen} id={id} check={check} />
            )}
          </div>
        </div>
      )}

      {/* quiz */}
      {/* Floating Quiz Button */}
      {/* Floating Quiz Button */}
      <button
        onClick={() => setQuizOpen(true)}
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          width: "60px",
          height: "60px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #4a1d85, #156fbc)",
          color: "#fff",
          fontSize: "16px",
          fontWeight: "600",
          border: "none",
          cursor: "pointer",
          zIndex: 1300,
          boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
        }}
      >
        Quiz
      </button>

      {/* Quiz Modal */}
      <Modal
        open={quizOpen}
        onClose={() => setQuizOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 400 }}
      >
        <Fade in={quizOpen}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "900px",
              maxHeight: "90vh",
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: 24,
              p: 3,
              overflowY: "auto",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setQuizOpen(false)}
              style={{
                position: "absolute",
                top: "12px",
                right: "16px",
                fontSize: "22px",
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
            >
              ✕
            </button>

            {/* Quiz Content */}
            <PlaylistQuiz playlistId={id} onClose={() => setQuizOpen(false)} />
          </Box>
        </Fade>
      </Modal>

      <Footer />
    </div>
  );
};
export default Creator;
